function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_ENTITIESBYTEXTCONTAINING_REQUEST = "GET_ENTITIESBYTEXTCONTAINING_REQUEST";
export var GET_ENTITIESBYTEXTCONTAINING_SUCCESS = "GET_ENTITIESBYTEXTCONTAINING_SUCCESS";
export var GET_ENTITIESBYTEXTCONTAINING_FAILURE = "GET_ENTITIESBYTEXTCONTAINING_FAILURE";
export var RESET_GET_ENTITIESBYTEXTCONTAINING = "RESET_GET_ENTITIESBYTEXTCONTAINING";

// Fetches entities by name containing value from Front API.
// Relies on Redux Thunk middleware.
export var loadEntitiesByTextContaining = function loadEntitiesByTextContaining(page, size, text) {
  var queryString = urlSearchParams({
    page: page,
    size: size,
    projection: "search",
    text: text
  });
  return _defineProperty({}, CALL_API, {
    types: [GET_ENTITIESBYTEXTCONTAINING_REQUEST, GET_ENTITIESBYTEXTCONTAINING_SUCCESS, GET_ENTITIESBYTEXTCONTAINING_FAILURE],
    endpoint: "entities/search/findByTextContaining".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var POST_ENTITY_REQUEST = "POST_ENTITY_REQUEST";
export var POST_ENTITY_SUCCESS = "POST_ENTITY_SUCCESS";
export var POST_ENTITY_FAILURE = "POST_ENTITY_FAILURE";
export var RESET_POST_ENTITY = "RESET_POST_ENTITY";
export var postEntity = function postEntity(entity) {
  return _defineProperty({}, CALL_API, {
    types: [POST_ENTITY_REQUEST, POST_ENTITY_SUCCESS, POST_ENTITY_FAILURE],
    endpoint: "entities",
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(entity),
      credentials: "same-origin"
    }
  });
};
export var resetPostEntity = function resetPostEntity() {
  return {
    type: RESET_POST_ENTITY
  };
};